var Interface = require('../core');
var _ = require('lodash');

var verifyTypeFactoryPatterns = function verifyTypeFactoryPatterns(val, stringPattern) {
  return (this.discoverType(val) === 'string') && stringPattern.test(val);
};

var convertToSyncPatterns = function convertTypePatterns(sourceValue) {
  return sourceValue + '';
};

Interface.type('pattern', {
  defaultValue: '',
  convertToSync: function (sourceValue) {
    return sourceValue + '';
  },
  isOfType: function verifyTypeFactory(val, req) {
    return (
      (this.discoverType(req.typeDef) === 'regexp') &&
      (this.discoverType(val) === 'string') &&
      req.typeDef.test(val)
    );
  }
});

var patternStringValidators = {
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i,
  snakecase: /^[a-z0-9-]+$/,
  email: /^[A-Za-z0-9._%+-]+@([A-Za-z0-9-]+\.)+([A-Za-z0-9]{2,4}|museum)$/,
  url: /^([a-z]+:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/i,
  phone: /(\+*\d{1,})*([ |\(])*(\d{3})[^\d]*(\d{3})[^\d]*(\d{4})/,
  zipcode: /^\d{5}(?:[-\s]\d{4})?$/
};

// zipcode needs optional -\d{4}
_.each(patternStringValidators, function addSpecificPatternTypes(regularExpression, interfaceType) {

  this.type(interfaceType, {
    defaultValue: '',
    convertToSync: convertToSyncPatterns,
    isOfType: function verifyTypeFactory(val, req) {
      return verifyTypeFactoryPatterns.call(this, val, regularExpression);
    }
  });

}, Interface);



// WEBPACK FOOTER //
// patterns.js